export interface ButtonsConfiguration {
  large: boolean;
  checkout: boolean;
  hold: boolean;
  return: boolean;
  renew: boolean;
  cancel: boolean;
  list: boolean;
  preview: boolean;
  favorite: boolean;
  calendar: boolean;
  attachedDownload: boolean;
  follow: boolean;
}

export class DefaultButtonConfiguration implements ButtonsConfiguration {
  private showReturnButton: boolean;

  constructor(showReturnButton = true) {
    this.showReturnButton = showReturnButton;
  }

  large = false;
  checkout = true;
  hold = true;
  renew = false;
  cancel = true;
  list = true;
  preview = true;
  favorite = true;
  calendar = false;
  attachedDownload = false;
  follow = false;

  get return(): boolean {
    return this.showReturnButton;
  }

  set return(value: boolean) {
    this.showReturnButton = value;
  }
}

export class ResultsButtonConfiguration extends DefaultButtonConfiguration {
  cancel = false;
  list = false;
  favorite = false;
  calendar = true;
  attachedDownload = true;
  follow = false;
}

export class InfoButtonConfiguration extends DefaultButtonConfiguration {
  constructor(showReturnButton = true) {
    super(showReturnButton);
  }

  favorite = false;
  list = false;
  calendar = true;
  attachedDownload = true;
}

export class CollectionButtonConfiguration extends DefaultButtonConfiguration {
  constructor(showReturnButton = true) {
    super(showReturnButton);
  }

  cancel = false;
  list = false;
  favorite = false;
  large = true;
  attachedDownload = true;
  follow = false;
}

export class CheckoutItemButtonConfiguration extends DefaultButtonConfiguration {
  constructor(showReturnButton = true) {
    super(showReturnButton);
  }

  renew = true;
  list = false;
  favorite = false;
}

export class FavoritesItemButtonConfiguration extends DefaultButtonConfiguration {
  renew = true;
  preview = false;
  list = false;
  favorite = false;
  attachedDownload = true;
}

export class HoldItemButtonConfiguration extends DefaultButtonConfiguration {
  constructor(showReturnButton = true) {
    super(showReturnButton);
  }

  renew = true;
  list = false;
  favorite = false;
  preview = false;
}

export class UserListButtonConfiguration extends DefaultButtonConfiguration {
  constructor(showReturnButton = true) {
    super(showReturnButton);
  }

  cancel = false;
  list = false;
  preview = false;
  favorite = false;
  follow = false;
}

export class HistoryButtonConfiguration implements ButtonsConfiguration {
  checkout = true;
  attachedDownload = false;
  calendar = false;
  cancel = false;
  favorite = false;
  hold = false;
  large = false;
  list = false;
  preview = false;
  renew = false;
  return = false;
  follow = false;
}

export class ListResultsButtonConfiguration extends DefaultButtonConfiguration {
  cancel = false;
  list = false;
  favorite = false;
  calendar = true;
  attachedDownload = true;
  follow = true;
}
